// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  moralisAppId:"6EFmbfe1KnwWwCeKL0vzi4mCGa7qOc3eaLKifc6j",
  moralisUrl:"https://ys75tvj3e9fz.grandmoralis.com:2053/server",
  //moralisAppId:"VDcPBUZJV8QshfT5pQg1YgG4UfbOnoWUyXuqC8Ql",
  //moralisUrl:"https://ikj2ljmz8ugk.moralishost.com:2053/server",
  chain:"hardhat",//Change to matic for production https://docs.moralis.io/moralis-server/web3-sdk/intro,
  queezTokenAdress:"0x5FbDB2315678afecb367f032d93F642f64180aa3",
  queezTokenUrl:"https://mumbai.polygonscan.com/token/0x6470F43c09fDe373c2B4Af92aBf136bA60D74da5",
  contractSaleAdress:"0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512",
  queezTokenSymbol:"QZCS"
};
 

/*
 moralisAppId:"w88KdxBibdcvbIX0F43errU8eHMU6atcEirrAQAr",
  moralisUrl:"https://y9wzbvhpqlii.moralishost.com:2053/server",
 
  */